import { IObjectFieldValueFile } from './project.d';

/**
 * Проверяет только первый элемент в массиве (если вообще был передан массив)
 */
export const isObjectFilesArray = (data: any): data is IObjectFieldValueFile[] => (
    Array.isArray(data) && (
        Object.prototype.hasOwnProperty.call(data[0], 'code')
        && Object.prototype.hasOwnProperty.call(data[0], 'id')
        && Object.prototype.hasOwnProperty.call(data[0], 'mime')
        && Object.prototype.hasOwnProperty.call(data[0], 'name')
        && Object.prototype.hasOwnProperty.call(data[0], 'path')
        && Object.prototype.hasOwnProperty.call(data[0], 'uuid')
    )
);
